import { FC } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import Header from '@/components/XPower/elements/Header';
import MoreButton from '@/components/XPower/elements/MoreButton';
import { LinkIcon } from '@/components/XPower/svg';
import Video from '@/components/XPower/elements/Video';

const XLink: FC = () => {
    const { t } = useLang('xcode.xlink');

    const mediaList = [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701262269/5.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701185737/X-link1.jpg',
            text: t.rich('media.media_text1', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719219237764/6.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719219212570/X-link2.jpg',
            text: t.rich('media.media_text2', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
    ];

    return (
        <div className={styled.XLink}>
            <Header icon={<LinkIcon />} desc={t('title')} subtitle={t('subtitle')} />
            <div className="big-central media_box">
                <Video src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718171869901/90kWh.mp4" />
            </div>
            {/* pc端 */}
            <div className="middle-central pc">
                <div className="text_box">
                    <div className="left font-desc">{t('text.left_text1')}</div>
                    <div className="right font-desc">
                        {t.rich('text.right_text1', {
                            line: (text: string) => <p>{text}</p>,
                        })}
                    </div>
                </div>
            </div>
            <div className="middle-central pc">
                <div className="text_box">
                    <div className="left font-desc">
                        {t.rich('text.left_text2', {
                            line: (text: string) => <span>{text}</span>,
                        })}
                    </div>
                    <div className="right font-desc">
                        {t.rich('text.right_text2', {
                            line: (text: string) => <p>{text}</p>,
                        })}
                    </div>
                </div>
                <p className="tips">{t('text.tips')}</p>
            </div>
            {/* 移动端 */}
            <div className="middle-central mobile">
                <div className="font-desc">{t('text.left_text1')}</div>
                <div className="font-desc">
                    {t.rich('text.left_text2', {
                        line: (text: string) => <span>{text}</span>,
                    })}
                </div>
                <p className="tips">{t('text.tips')}</p>
                <div className="kw_list">
                    <div className="font-desc">
                        {t.rich('text.right_text1', {
                            line: (text: string) => <p>{text}</p>,
                        })}
                    </div>
                    <div className="font-desc">
                        {t.rich('text.right_text2', {
                            line: (text: string) => <p>{text}</p>,
                        })}
                    </div>
                </div>
            </div>
            <MoreButton text={t('btn_more')} mediaList={mediaList} />
        </div>
    );
};

export default XLink;
